import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import React__default from 'react';
import { mobile, app } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import qs from 'qs';
import { openApp } from '../open-app/index.js';
import { WxOpenLaunchApp } from './components/wx-open-launch-app.js';
import { isWxOpenBtn, LAND_PAGE_URL } from './utils/constant.js';

var inWeibo = mobile.isWeiboBrowser();

var createExtInfo = function createExtInfo(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type,
      _ref$path = _ref.path,
      path = _ref$path === void 0 ? '' : _ref$path,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  if (!type) {
    return '';
  }

  var _app$getAppLink = app.getAppLink({
    type: type,
    path: path,
    options: options
  }),
      url = _app$getAppLink.url;

  return url;
};

var OpenAppBtn = function OpenAppBtn(_ref2) {
  var _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? '' : _ref2$type,
      path = _ref2.path,
      options = _ref2.options,
      className = _ref2.className,
      _ref2$extraOptions = _ref2.extraOptions,
      extraOptions = _ref2$extraOptions === void 0 ? {} : _ref2$extraOptions,
      fallbackFunc = _ref2.fallbackFunc,
      children = _ref2.children;
  var extInfo = {
    type: type,
    path: path,
    options: options
  };
  var extInfoUrl = createExtInfo(extInfo);

  var handleOpenApp = function handleOpenApp() {
    if (inWeibo) {
      if (fallbackFunc) {
        fallbackFunc();
      } else {
        var _context;

        window.location.href = _concatInstanceProperty(_context = "".concat(LAND_PAGE_URL)).call(_context, extInfoUrl ? qs.stringify({
          url: extInfoUrl
        }, {
          addQueryPrefix: true
        }) : '');
      }
    } else {
      var _extInfo$type = extInfo.type,
          realType = _extInfo$type === void 0 ? '' : _extInfo$type,
          realPath = extInfo.path,
          realOptions = extInfo.options;
      openApp({
        type: realType,
        path: realPath,
        options: realOptions
      }, extraOptions);
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('prelude-open-app-btn-box', className)
  }, children, isWxOpenBtn ? /*#__PURE__*/React__default.createElement(WxOpenLaunchApp, {
    extInfoUrl: extInfoUrl,
    fallbackFunc: fallbackFunc
  }) : /*#__PURE__*/React__default.createElement("div", {
    onClick: handleOpenApp,
    className: "prelude-open-app-btn-inner"
  }));
};

export { OpenAppBtn };
